import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss'],
})
export class OffersComponent implements AfterViewInit {
  offers$ = this.viewOffersService.offers$;

  constructor(public readonly viewOffersService: ViewOffersService) {}

  ngAfterViewInit(): void {
    this.viewOffersService.scrollIntoView('header', 'smooth');
  }
}
